// Author liang gang qiang
// Date 2021-11-25 16:25:20

import * as model from "@/model/mintalMes/prd/MintalMesPrdCraftMaterialConfigModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdCraftMaterialConfig(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
        selectRowsToItems: function (row) {
            return {value: row.materialId, text: row.mstMaterialName}
        },
    })
    .buildStore()
